import api from '../config';
import URLS from '../../../shared/constants/urls';
export const _createMap3DObject = (siteId, name, mapObjectFile) => {
    const response = api.post(`${URLS.MAP_OBJECT_3D}/create/${siteId}?name=${name}`, mapObjectFile);
    return response;
};
export const _getMap3dObject = (siteId) => {
    const response = api.get(`${URLS.MAP_OBJECT_3D}/${siteId}?pageNumber=0&pageSize=100`);
    return response;
};
export const _deleteMap3DObject = (siteId, mapObjectId) => {
    const response = api.delete(`${URLS.MAP_OBJECT_3D}/${siteId}/${mapObjectId}`);
    return response;
};
export const _createMap3DObjectProperty = (data) => {
    const response = api.post(`${URLS.MAP_OBJECT_3D_PROPERTY}/create`, data);
    return response;
};
export const _getMap3DObjectProperties = (siteId, pageNumber, pageSize) => {
    const response = api.get(`${URLS.MAP_OBJECT_3D_PROPERTY}/${siteId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response;
};
export const _updateMap3DObjectProperty = (siteId, mapObjectPropertyId, data) => {
    const response = api.put(`${URLS.MAP_OBJECT_3D_PROPERTY}/update/${siteId}/${mapObjectPropertyId}`, data);
    return response;
};
export const _deleteMap3DObjectProperty = (siteId, mapObjectPropertyId) => {
    const response = api.delete(`${URLS.MAP_OBJECT_3D_PROPERTY}/delete/${siteId}/${mapObjectPropertyId}`);
    return response;
};
export const _getMap3DObjectProperty = (siteId, mapObjectPropertyId) => {
    const response = api.get(`${URLS.MAP_OBJECT_3D_PROPERTY}/get/${siteId}/${mapObjectPropertyId}`);
    return response;
};
